const version = () => "v0.9.63";

export default version;
